import type { CheckoutPassenger } from '@/types/passenger';
import type { Paths } from '@/types/schemas/agent-schema';

export type UpdatePassengerFormValues = Partial<Omit<CheckoutPassenger, 'id'>>;

const compact = (entries: Record<string, string | undefined>) =>
  Object.fromEntries(
    Object.entries(entries).filter(([, value]) => value !== '' && value != null)
  );

export const buildUpdatePassengerPayload = (
  values: UpdatePassengerFormValues
): Paths.BookingsUpdatePassenger.RequestBody => {
  const {
    externalReference,
    firstName,
    lastName,
    email,
    phoneNumber,
    birthDate,
    gender,
    zipCode,
    stateCode,
    companyUnitCode,
  } = values;

  const address = compact({ zipCode, stateCode });
  const companyDetails = compact({ unitCode: companyUnitCode });

  return {
    ...compact({
      externalReference,
      firstName,
      lastName,
      email,
      phoneNumber,
      birthDate,
      gender,
    }),
    ...(Object.keys(address).length > 0 ? { address } : {}),
    ...(Object.keys(companyDetails).length > 0 ? { companyDetails } : {}),
  };
};
